import { indexProjectBatchesOperation, indexBatchFilesOperation } from "@api/services/backstage";

import type { Batch, Request, InvestorFile } from "../types";

type BatchesOutput = {
  data: Batch[];
};

type FilesOutput = {
  data: InvestorFile[];
};

export const listProjectBatches = async (request: Request, projectId: string): Promise<Batch[]> => {
  const { data: projectBatches } = await request<BatchesOutput>(indexProjectBatchesOperation, { projectId });

  return projectBatches;
};

const listProjectFiles = async (
  request: Request,
  projectId: string,
): Promise<[Batch[], InvestorFile[]]> => {
  const files: InvestorFile[] = [];

  const projectBatches = await listProjectBatches(request, projectId);

  // NOTE: Include only investor files and not project files.
  const investorBatches = projectBatches
    .filter((batch) => !batch.fileUrl);

  const promises = investorBatches
    .map(({ id: batchId }) =>
      request<FilesOutput>(indexBatchFilesOperation, { batchId })
        .then(({ data: batchFiles }) => files.push(...batchFiles)),
    );

  await Promise.all(promises);

  return [ investorBatches, files ];
};

export default listProjectFiles;
